import { z } from 'zod';

import {
    PAYMENT_METHODS,
    paymentRefundObjectSchema,
    refinePaymentRefund,
} from '@/entities/payment';

export const refundPaymentFormSchema = paymentRefundObjectSchema
    .omit({ id: true, paymentId: true, practiceId: true, practiceMemberId: true, clientId: true })
    .extend({
        method: z.enum(PAYMENT_METHODS, 'Select a refund method').exclude(['CARD_ON_FILE']),
    })
    .superRefine(refinePaymentRefund);

export type RefundPaymentFormValues = z.input<typeof refundPaymentFormSchema>;
export type RefundPaymentFormOutput = z.output<typeof refundPaymentFormSchema>;
